// @ts-nocheck
/* eslint no-var: 0 */
export const initAnalytics = (urlAnalytics: string) => {
  if (urlAnalytics && urlAnalytics.length > 0) {
    console.log("urlAnalytics : " + urlAnalytics);
    var _mtm = window._mtm = window._mtm || [];
    _mtm.push({'mtm.startTime': (new Date().getTime()), 'event': 'mtm.Start'});
    (function() {
      var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
      g.async=true;
      g.src=urlAnalytics
      s.parentNode.insertBefore(g,s);
    })();
  }
};

